import { Skeleton, Row, Column } from 'components/Blocks';

export function LoadingRecruitment() {
  return (
    <>
      <Row justifyContent="space-between">
        <Row gap="3" fullWidth={false}>
          <Skeleton height={36} width={36} circle />

          <Skeleton height={36} width={140} />
        </Row>

        <Skeleton height={36} width={80} />
      </Row>

      <Skeleton height={32} width="75px" quantity={3} orientation="horizontal" />

      <Column>
        <Skeleton height={24} width={120} />

        <Skeleton quantity={4} height={48} />
      </Column>
    </>
  );
}
